import useProfile from "api/UserResource/useProfile";
import { FiMapPin, FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import AccountPage from "../AccountPage";
import AccountLayout from "../AccountLayout";
import useGetUserShippingAddresses from "api/AddressResource/useGetUserShippingAddresses";
import DeleteShippingAddress from "./DeleteShippingAddress";
import EditShippingAddress from "./EditShippingAddress";

const MyAddresses = () => {
	const { data: profile, isLoading } = useProfile();
	const {
		data: addresses,
		isLoading: loadingAddresses,
		isError,
		refetch,
	} = useGetUserShippingAddresses();
	return (
		<AccountPage>
			<AccountLayout isLoading={isLoading || loadingAddresses} profile={profile?.data}>
				{isError ? (
					<div className="account-empty" role="alert">
						<FiMapPin aria-hidden="true" />
						<h2>Addresses couldn’t be loaded</h2>
						<p>Please try again in a moment.</p>
						<button type="button" className="account-button" onClick={() => refetch()}>
							Try again
						</button>
					</div>
				) : !addresses?.length ? (
					<div className="account-empty">
						<FiMapPin aria-hidden="true" />
						<h2>No saved addresses yet</h2>
						<p>Your delivery addresses are saved when you check out with a printed book.</p>
						<Link to="/books" className="account-button">
							Browse books <FiArrowRight aria-hidden="true" />
						</Link>
					</div>
				) : (
					<>
						<div className="account-section-heading">
							<h2>Saved for your next delivery</h2>
							<p>
								Edit the address label and recipient details, or remove an address you no longer
								use.
							</p>
						</div>
						<div className="account-address-grid">
							{addresses.map((address) => (
								<article key={address.id} className="account-address">
									<header className="account-address-heading">
										<FiMapPin aria-hidden="true" />
										<h2>{address.nickname || "Delivery address"}</h2>
									</header>
									<div className="account-address-body">
										<p>{address.street_address}</p>
										<p>{[address.suburb, address.city].filter(Boolean).join(", ")}</p>
										<p>{address.country}</p>
										<dl>
											<dt>Recipient</dt>
											<dd>{address.recipient_name}</dd>
											<dt>Phone number</dt>
											<dd>{address.recipient_phone}</dd>
										</dl>
									</div>
									<div className="account-address-actions">
										<EditShippingAddress
											addressId={address.id}
											nickname={address.nickname}
											recipientName={address.recipient_name}
											recipientPhone={address.recipient_phone}
										/>
										<DeleteShippingAddress addressId={address.id} nickname={address.nickname} />
									</div>
								</article>
							))}
						</div>
					</>
				)}
			</AccountLayout>
		</AccountPage>
	);
};
export default MyAddresses;
